if (!customElements.get('desktop-vertical-gallery')) {
    customElements.define('desktop-vertical-gallery', class DesktopVerticalGallery extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.listContainer = this.querySelector('.xl-thumbnails-list');
        this.thumbnails = this.querySelectorAll('.xl-thumbnail-btn');
        this.counterCurrent = this.querySelector('[data-current]');

        this.nativeThumbnails = this.querySelectorAll('.pdp-main-gallery .product-gallery__media-slide[data-product-slide]');
  
        this.bindEvents();
        this.initDragToScroll();
      }
  
      bindEvents() {
        this.thumbnails.forEach((btn, index) => {
          btn.addEventListener('click', () => {
            this.setActiveState(index);
            this.triggerNativeGallery(index, btn);
          });
        });

        document.addEventListener('theme:slider:changed', (e) => {
          if (e.detail && typeof e.detail.index === 'number') {
            this.setActiveState(e.detail.index);
          }
        });
      }
  
      setActiveState(index) {
        if (!this.thumbnails[index]) return;

        this.thumbnails.forEach(btn => btn.classList.remove('is-active'));
        const activeBtn = this.thumbnails[index];
        activeBtn.classList.add('is-active');

        if (this.counterCurrent) {
          this.counterCurrent.textContent = index + 1;
        }

        activeBtn.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
  
      triggerNativeGallery(index, btn) {
        const pdpWrapper = document.querySelector(".product-single__wrapper");
        
        if (pdpWrapper && pdpWrapper.flkty?.select) {
            pdpWrapper.flkty.select(index);
        }
      }

      initDragToScroll() {
        if (!this.listContainer) return;
  
        let isDown = false;
        let startY;
        let scrollTop;
  
        this.listContainer.addEventListener('mousedown', (e) => {
          isDown = true;
          startY = e.pageY - this.listContainer.offsetTop;
          scrollTop = this.listContainer.scrollTop;
        });
  
        this.listContainer.addEventListener('mouseleave', () => { isDown = false; });
        this.listContainer.addEventListener('mouseup', () => { isDown = false; });
  
        this.listContainer.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const y = e.pageY - this.listContainer.offsetTop;
          const walk = (y - startY) * 1.5;
          this.listContainer.scrollTop = scrollTop - walk;
        });
      }
    });
}